module.exports = __webpack_public_path__ + "img/shifthealth_login_logo.18e4d1bb.png";